import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submit-successfull',
  templateUrl: './submit-successfull.component.html',
  styleUrls: ['./submit-successfull.component.css']
})
export class SubmitSuccessfullComponent implements OnInit {

  constructor(private router: Router) {
    // setTimeout(() => {
    //   this.router.navigate(['home']).then((data) => {
    //     location.reload();
    //   })
    // }, 4000)
  }

  ngOnInit() {
  }

}
